module.exports = __webpack_public_path__ + "static/media/CI.90cb212b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/CI.svg
// module id = 2128
// module chunks = 7